import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import {RootState, AppDispatch} from './store';

// These get imported in our components instead of the base functions from react redux
export const useAppDispatch = () => useDispatch<AppDispatch>();
// function being aliased using types
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
